// AUTO-GENERATED from Backend v3.0 — 76 entries
export type AliasBrand = "AJAX" | "DAITEM" | "INIM" | "INIM_EXTRA" | "NOTIFIER";

export type AliasEntry = {
  sigla: string;
  extended: string;
  brand: AliasBrand;
  famiglia: string;
  categoria: string;
  spec_key: string;
  primary_manual: string | null;
  model_canonico?: string;
  related: string[];
  synonyms?: string[];
};

const ALIASES_GLOSSARY: AliasEntry[] = 
[
  {
    "sigla": "Hub 2",
    "extended": "Centrale Hub 2 Jeweller",
    "brand": "AJAX",
    "famiglia": "Centrali",
    "categoria": "Hub/Centrali",
    "spec_key": "100 dispositivi, raggio Jeweller 2000m, Ethernet + 2 SIM",
    "primary_manual": "AJAX__Hub-2-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "Hub",
      "Hub 2 Plus",
      "Superior Hub G3"
    ]
  },
  {
    "sigla": "Hub 2 Plus",
    "extended": "Centrale Hub 2 Plus Jeweller+Wings",
    "brand": "AJAX",
    "famiglia": "Centrali",
    "categoria": "Hub/Centrali",
    "spec_key": "200 dispositivi (max), Jeweller 2000m + Wings + Wi-Fi + 2 SIM",
    "primary_manual": "AJAX__Hub-2-Plus-8-ECG-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "Hub 2",
      "Superior Hub G3"
    ]
  },
  {
    "sigla": "Hub",
    "extended": "Centrale Hub (1° gen)",
    "brand": "AJAX",
    "famiglia": "Centrali",
    "categoria": "Hub/Centrali",
    "spec_key": "100 dispositivi, Jeweller 2000m, Ethernet + 1 SIM",
    "primary_manual": "AJAX__Hub-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "Hub 2"
    ]
  },
  {
    "sigla": "Hub 2 4G",
    "extended": "Hub 2 con modem 4G",
    "brand": "AJAX",
    "famiglia": "Centrali",
    "categoria": "Hub/Centrali",
    "spec_key": "100 dispositivi, Jeweller 2000m, Ethernet + 4G",
    "primary_manual": "AJAX__Hub-2G-4G-Jeweller__Manuale-Utente__IT.pdf",
    "related": [
      "Hub 2"
    ]
  },
  {
    "sigla": "MotionProtect",
    "extended": "Rilevatore PIR interno Jeweller",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Rilevatori movimento",
    "spec_key": "12m raggio, 5 anni batteria, ignora animali fino 50cm/20kg, install 2,4m",
    "primary_manual": "AJAX__MotionProtect-Jeweller__Manuale-Utente__IT.pdf",
    "related": [
      "MotionProtect Plus",
      "MotionProtect Outdoor",
      "MotionProtect Curtain",
      "MotionCam"
    ]
  },
  {
    "sigla": "MotionProtect Plus",
    "extended": "PIR + microonde",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Rilevatori movimento",
    "spec_key": "12m raggio, doppia tecnologia PIR+MW, comunicazione 1200m (NON 1700)",
    "primary_manual": "AJAX__MotionProtect-Plus-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "MotionProtect"
    ]
  },
  {
    "sigla": "MotionProtect Outdoor",
    "extended": "PIR esterno anti-mascheramento",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Rilevatori movimento",
    "spec_key": "15m raggio, esterno IP54, animali fino 80cm",
    "primary_manual": "AJAX__MotionProtect-Outdoor-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "MotionProtect",
      "MotionCam Outdoor"
    ]
  },
  {
    "sigla": "MotionProtect Curtain",
    "extended": "PIR a tenda",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Rilevatori movimento",
    "spec_key": "15m angolo stretto, batteria 3 anni (NON 5)",
    "primary_manual": "AJAX__MotionProtect-Curtain-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "MotionProtect"
    ]
  },
  {
    "sigla": "MotionCam",
    "extended": "MotionProtect + foto via Wings",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Rilevatori movimento",
    "spec_key": "12m + verifica visiva foto via Wings",
    "primary_manual": "AJAX__MotionCam-Jeweller__Manuale-Utente__IT.pdf",
    "related": [
      "MotionProtect",
      "MotionCam Outdoor"
    ]
  },
  {
    "sigla": "CombiProtect",
    "extended": "PIR + glass break",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Rilevatori movimento",
    "spec_key": "12m PIR + rottura vetro",
    "primary_manual": "AJAX__CombiProtect-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "MotionProtect",
      "GlassProtect"
    ]
  },
  {
    "sigla": "DoorProtect",
    "extended": "Contatto magnetico porta/finestra",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Contatti",
    "spec_key": "Reed magnetico, 5 anni batteria, oltre 2M aperture, magnete grande 2cm",
    "primary_manual": "AJAX__DoorProtect-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "DoorProtect Plus",
      "Superior DoorProtect"
    ]
  },
  {
    "sigla": "DoorProtect Plus",
    "extended": "Contatto magnetico + colpi/tilt",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Contatti",
    "spec_key": "Reed + sensore colpi/tilt, 5 anni batteria",
    "primary_manual": "AJAX__DoorProtect-Plus-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "DoorProtect"
    ]
  },
  {
    "sigla": "GlassProtect",
    "extended": "Rilevatore rottura vetro",
    "brand": "AJAX",
    "famiglia": "Rilevatori",
    "categoria": "Contatti",
    "spec_key": "Vetro, 7 anni batteria",
    "primary_manual": "AJAX__GlassProtect-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "CombiProtect"
    ]
  },
  {
    "sigla": "FireProtect",
    "extended": "Rilevatore fumo + temperatura",
    "brand": "AJAX",
    "famiglia": "Antincendio",
    "categoria": "Antincendio",
    "spec_key": "Fumo + temp, 4 anni batteria (NON 5), allarme sopra 60°C",
    "primary_manual": "AJAX__FireProtect-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "FireProtect Plus",
      "FireProtect 2"
    ]
  },
  {
    "sigla": "FireProtect Plus",
    "extended": "FireProtect + sensore CO",
    "brand": "AJAX",
    "famiglia": "Antincendio",
    "categoria": "Antincendio",
    "spec_key": "Fumo + temp + CO, 4 anni batteria",
    "primary_manual": "AJAX__FireProtect-Plus-with-CO-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "FireProtect"
    ]
  },
  {
    "sigla": "HomeSiren",
    "extended": "Sirena interna wireless",
    "brand": "AJAX",
    "famiglia": "Sirene",
    "categoria": "Sirene interne",
    "spec_key": "100 dB max (livelli 80/93/100), 5 anni batteria",
    "primary_manual": "AJAX__HomeSiren-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "Superior HomeSiren"
    ]
  },
  {
    "sigla": "Superior HomeSiren",
    "extended": "Sirena interna Premium",
    "brand": "AJAX",
    "famiglia": "Sirene",
    "categoria": "Sirene interne",
    "spec_key": "105 dB max (vs 100 base), Fibra/Jeweller/G3",
    "primary_manual": "AJAX__Superior-HomeSiren-Jeweller__Manuale-Utente__IT.pdf",
    "related": [
      "HomeSiren"
    ]
  },
  {
    "sigla": "StreetSiren",
    "extended": "Sirena esterna wireless con LED",
    "brand": "AJAX",
    "famiglia": "Sirene",
    "categoria": "Sirene esterne",
    "spec_key": "113 dB max, esterno IP54, 5 anni batteria, LED lampeggio",
    "primary_manual": "AJAX__StreetSiren-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "StreetSiren DoubleDeck",
      "Superior StreetSiren"
    ]
  },
  {
    "sigla": "StreetSiren DoubleDeck",
    "extended": "Sirena esterna doppio altoparlante",
    "brand": "AJAX",
    "famiglia": "Sirene",
    "categoria": "Sirene esterne",
    "spec_key": "113 dB max, doppio altoparlante, 5 anni batteria",
    "primary_manual": "AJAX__StreetSiren-DoubleDeck-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "StreetSiren"
    ]
  },
  {
    "sigla": "Superior StreetSiren Plus Jeweller",
    "extended": "StreetSiren Plus wireless",
    "brand": "AJAX",
    "famiglia": "Sirene",
    "categoria": "Sirene esterne",
    "spec_key": "107 dB max (NON 113), Jeweller",
    "primary_manual": "AJAX__Superior-StreetSiren-Plus-Jeweller__Manuale-Utente__IT.pdf",
    "related": [
      "StreetSiren",
      "Superior StreetSiren"
    ]
  },
  {
    "sigla": "KeyPad",
    "extended": "Tastiera Jeweller con cifre",
    "brand": "AJAX",
    "famiglia": "Tastiere",
    "categoria": "Tastiere/Telecomandi",
    "spec_key": "4-6 cifre, raggio comunicazione 1700m",
    "primary_manual": "AJAX__Keypad-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "KeyPad Plus",
      "KeyPad TouchScreen"
    ]
  },
  {
    "sigla": "KeyPad Plus",
    "extended": "KeyPad + lettore RFID",
    "brand": "AJAX",
    "famiglia": "Tastiere",
    "categoria": "Tastiere/Telecomandi",
    "spec_key": "4-6 cifre + RFID, wireless",
    "primary_manual": "AJAX__Keypad-Plus-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "KeyPad"
    ]
  },
  {
    "sigla": "KeyPad TouchScreen",
    "extended": "Tastiera touchscreen",
    "brand": "AJAX",
    "famiglia": "Tastiere",
    "categoria": "Tastiere/Telecomandi",
    "spec_key": "Touchscreen, wireless",
    "primary_manual": "AJAX__KeyPad-TouchScreen-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "KeyPad"
    ]
  },
  {
    "sigla": "SpaceControl",
    "extended": "Telecomando 4 tasti",
    "brand": "AJAX",
    "famiglia": "Telecomandi",
    "categoria": "Tastiere/Telecomandi",
    "spec_key": "4 tasti, wireless",
    "primary_manual": "AJAX__SpaceControl-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "KeyPad"
    ]
  },
  {
    "sigla": "ReX",
    "extended": "Range Extender wireless",
    "brand": "AJAX",
    "famiglia": "Accessori",
    "categoria": "Range Extender",
    "spec_key": "Estende raggio Jeweller, wireless only",
    "primary_manual": "AJAX__ReX-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "ReX 2"
    ]
  },
  {
    "sigla": "ReX 2",
    "extended": "Range Extender wireless + Ethernet",
    "brand": "AJAX",
    "famiglia": "Accessori",
    "categoria": "Range Extender",
    "spec_key": "Wireless + Ethernet (doppia comunicazione hub)",
    "primary_manual": "AJAX__ReX-2-ASP__Manuale-Utente__IT.pdf",
    "related": [
      "ReX"
    ]
  },
  {
    "sigla": "TwinBand",
    "extended": "Tecnologia radio DAITEM doppia banda",
    "brand": "DAITEM",
    "famiglia": "Protocollo",
    "categoria": "Protocollo radio",
    "spec_key": "433-434 MHz + 868-870 MHz, max 25mW @ 868, duty cycle 0,1%",
    "primary_manual": null,
    "related": []
  },
  {
    "sigla": "SH275AX",
    "extended": "Rivelatore apertura mini E-Nova",
    "brand": "DAITEM",
    "famiglia": "E-Nova",
    "categoria": "Rilevatori",
    "spec_key": "3 anni autonomia uso normale, 1× CR2032 3V soglia 2,2V, 868 MHz",
    "primary_manual": "DAITEM__E-Nova__SH275AX-SH276AX-SH277AX__Manuale-Installazione__IT.pdf",
    "related": [
      "SH276AX",
      "SH277AX"
    ]
  },
  {
    "sigla": "SH276AX",
    "extended": "Rivelatore apertura mini variante",
    "brand": "DAITEM",
    "famiglia": "E-Nova",
    "categoria": "Rilevatori",
    "spec_key": "Stessa serie SH275AX, 3 anni autonomia",
    "primary_manual": "DAITEM__E-Nova__SH275AX-SH276AX-SH277AX__Manuale-Installazione__IT.pdf",
    "related": [
      "SH275AX",
      "SH277AX"
    ]
  },
  {
    "sigla": "SH277AX",
    "extended": "Rivelatore apertura mini variante",
    "brand": "DAITEM",
    "famiglia": "E-Nova",
    "categoria": "Rilevatori",
    "spec_key": "Stessa serie SH275AX, 3 anni autonomia",
    "primary_manual": "DAITEM__E-Nova__SH275AX-SH276AX-SH277AX__Manuale-Installazione__IT.pdf",
    "related": [
      "SH275AX",
      "SH276AX"
    ]
  },
  {
    "sigla": "SH100AX",
    "extended": "Centrale E-Nova",
    "brand": "DAITEM",
    "famiglia": "E-Nova",
    "categoria": "Centrali",
    "spec_key": "Centrale wireless residenziale, alimentazione rete",
    "primary_manual": "DAITEM__E-Nova__SH100AX-Multi__Manuale-Installazione__MULTI__Ver-B.pdf",
    "related": [
      "SH158AX"
    ]
  },
  {
    "sigla": "SH158AX",
    "extended": "Centrale E-Nova",
    "brand": "DAITEM",
    "famiglia": "E-Nova",
    "categoria": "Centrali",
    "spec_key": "Centrale wireless residenziale",
    "primary_manual": "DAITEM__E-Nova__SH158AX__Manuale-Installazione__MULTI.pdf",
    "related": [
      "SH100AX"
    ]
  },
  {
    "sigla": "SH350AT",
    "extended": "Centrale E-Nova",
    "brand": "DAITEM",
    "famiglia": "E-Nova",
    "categoria": "Centrali",
    "spec_key": "Centrale wireless",
    "primary_manual": "DAITEM__E-Nova__SH330AT-SH350AT-SH380AT__Manuale-Installazione__IT.pdf",
    "related": [
      "SH330AT",
      "SH380AT"
    ]
  },
  {
    "sigla": "SH424AI",
    "extended": "Sirena interna E-Nova",
    "brand": "DAITEM",
    "famiglia": "E-Nova",
    "categoria": "Sirene",
    "spec_key": "Sirena interna wireless",
    "primary_manual": null,
    "related": []
  },
  {
    "sigla": "SK202AX",
    "extended": "Ricevitore radio 1 uscita relè",
    "brand": "DAITEM",
    "famiglia": "Confort",
    "categoria": "Ricevitori radio",
    "spec_key": "1 contatto 16 A 230V~ AC1, 868.3 MHz banda singola",
    "primary_manual": "DAITEM__Confort__SK202AX__Manuale-Utente__IT.pdf",
    "related": [
      "SK204AX",
      "SK205AX",
      "SK206AX"
    ]
  },
  {
    "sigla": "SK204AX",
    "extended": "Ricevitore radio volet/store + 1 IN",
    "brand": "DAITEM",
    "famiglia": "Confort",
    "categoria": "Ricevitori radio",
    "spec_key": "2 contatti 5 A 230V~ AC1, NON 16A (è SK202), NON 12V/40mA",
    "primary_manual": "DAITEM__Confort__SK204AX__Manuale-Utente__IT.pdf",
    "related": [
      "SK202AX",
      "SK205AX",
      "SK206AX"
    ]
  },
  {
    "sigla": "SK205AX",
    "extended": "Ricevitore radio 1 IN + 1 OUT",
    "brand": "DAITEM",
    "famiglia": "Confort",
    "categoria": "Ricevitori radio",
    "spec_key": "1 contatto 10 A 230V~ AC1, 868.3 MHz",
    "primary_manual": "DAITEM__Confort__SK205AX__Manuale-Utente__IT.pdf",
    "related": [
      "SK202AX",
      "SK204AX"
    ]
  },
  {
    "sigla": "SK206AX",
    "extended": "Ricevitore radio volet/store",
    "brand": "DAITEM",
    "famiglia": "Confort",
    "categoria": "Ricevitori radio",
    "spec_key": "2 contatti 5 A 230V~ AC1",
    "primary_manual": "DAITEM__Confort__SK206AX__Manuale-Utente__IT.pdf",
    "related": [
      "SK204AX"
    ]
  },
  {
    "sigla": "SK506AX",
    "extended": "Ricevitore Confort multi",
    "brand": "DAITEM",
    "famiglia": "Confort",
    "categoria": "Ricevitori radio",
    "spec_key": "Ricevitore multi-uscita",
    "primary_manual": "DAITEM__Confort__SK506AX__Manuale-Utente__MULTI.pdf",
    "related": [
      "SK202AX",
      "SK204AX"
    ]
  },
  {
    "sigla": "SH156AX",
    "extended": "Centrale Pro",
    "brand": "DAITEM",
    "famiglia": "Pro",
    "categoria": "Centrali",
    "spec_key": "Centrale professionale wireless",
    "primary_manual": "DAITEM__Pro__SH156AX__Manuale-Installazione__IT.pdf",
    "related": [
      "SH158AX Pro"
    ]
  },
  {
    "sigla": "SH330AX",
    "extended": "Centrale Pro",
    "brand": "DAITEM",
    "famiglia": "Pro",
    "categoria": "Centrali",
    "spec_key": "Centrale serie 330",
    "primary_manual": "DAITEM__Pro__SH330AX-SH360AX-SH385AX__Manuale-Installazione__IT.pdf",
    "related": [
      "SH360AX",
      "SH385AX"
    ]
  },
  {
    "sigla": "SH421AX",
    "extended": "Centrale Pro",
    "brand": "DAITEM",
    "famiglia": "Pro",
    "categoria": "Centrali",
    "spec_key": "Centrale professionale serie 421",
    "primary_manual": "DAITEM__Pro__SH421AX__Manuale-Installazione__IT.pdf",
    "related": []
  },
  {
    "sigla": "SL330AX",
    "extended": "Sirena Pro",
    "brand": "DAITEM",
    "famiglia": "Pro",
    "categoria": "Sirene",
    "spec_key": "Sirena Pro serie 330",
    "primary_manual": "DAITEM__Pro__SL330AX-SL360AX-SL385AX__Manuale-Installazione__IT.pdf",
    "related": [
      "SL360AX",
      "SL385AX"
    ]
  },
  {
    "sigla": "Primera 320",
    "extended": "Centrale Primera 320-21I",
    "brand": "DAITEM",
    "famiglia": "Primera",
    "categoria": "Centrali",
    "spec_key": "Centrale 30 zone, allarme professionale",
    "primary_manual": "DAITEM__Primera__320-21I__Manuale-Installazione__IT.pdf",
    "related": [
      "Primera 362"
    ]
  },
  {
    "sigla": "TTView",
    "extended": "App e remote DAITEM",
    "brand": "DAITEM",
    "famiglia": "TTView",
    "categoria": "App/Remote",
    "spec_key": "Sistema view e controllo remoto",
    "primary_manual": "DAITEM__TTView__330-23X-485-21X__Manuale-Installazione__IT.pdf",
    "related": []
  },
  {
    "sigla": "SmartLiving 505",
    "extended": "Centrale antintrusione base",
    "brand": "INIM",
    "famiglia": "SmartLiving",
    "categoria": "Antintrusione",
    "spec_key": "5 terminali, 5 aree, 10 zone",
    "primary_manual": "SmartLiving_Manuale_Installazione.pdf",
    "related": [
      "SmartLiving 515",
      "SmartLiving 1050"
    ]
  },
  {
    "sigla": "SmartLiving 515",
    "extended": "Centrale antintrusione piccola",
    "brand": "INIM",
    "famiglia": "SmartLiving",
    "categoria": "Antintrusione",
    "spec_key": "15 terminali, 10 aree, 15 zone (terminali ≠ aree)",
    "primary_manual": "SmartLiving_Manuale_Installazione.pdf",
    "related": [
      "SmartLiving 505",
      "SmartLiving 1050"
    ]
  },
  {
    "sigla": "SmartLiving 1050",
    "extended": "Centrale antintrusione media",
    "brand": "INIM",
    "famiglia": "SmartLiving",
    "categoria": "Antintrusione",
    "spec_key": "50 terminali, 15 aree, 30 zone. Variante G3 = EN50131-6 grado 3",
    "primary_manual": "SmartLiving_Manuale_Installazione.pdf",
    "related": [
      "SmartLiving 1050L",
      "SmartLiving 10100L"
    ]
  },
  {
    "sigla": "SmartLiving 10100L",
    "extended": "Centrale antintrusione grande",
    "brand": "INIM",
    "famiglia": "SmartLiving",
    "categoria": "Antintrusione",
    "spec_key": "100 terminali, 20 aree, 100 zone",
    "primary_manual": "SmartLiving_Manuale_Installazione.pdf",
    "related": [
      "SmartLiving 1050"
    ]
  },
  {
    "sigla": "Prime 060S",
    "extended": "Centrale Prime base",
    "brand": "INIM",
    "famiglia": "Prime",
    "categoria": "Antintrusione",
    "spec_key": "10-60 terminali, EN50131 grado 3",
    "primary_manual": "Prime_Manuale_Installazione.pdf",
    "related": [
      "Prime 120L",
      "Prime 500L"
    ]
  },
  {
    "sigla": "Prime 500L",
    "extended": "Centrale Prime top di gamma",
    "brand": "INIM",
    "famiglia": "Prime",
    "categoria": "Antintrusione",
    "spec_key": "500 terminali max, 30 aree, 4000 eventi memoria, LAN + Inim Cloud",
    "primary_manual": "Prime_Manuale_Installazione.pdf",
    "related": [
      "Prime 240L",
      "PrimeX"
    ]
  },
  {
    "sigla": "PrimeX",
    "extended": "Variante X di Prime",
    "brand": "INIM",
    "famiglia": "Prime",
    "categoria": "Antintrusione",
    "spec_key": "Versione X della serie Prime",
    "primary_manual": "PrimeX_Manuale_Installazione.pdf",
    "related": [
      "Prime 500L"
    ]
  },
  {
    "sigla": "SmartLine 020-2",
    "extended": "Centrale antincendio 2 zone",
    "brand": "INIM",
    "famiglia": "SmartLine",
    "categoria": "Antincendio",
    "spec_key": "2 zone convenzionali NON espandibili, 32 disp/zona",
    "primary_manual": "SmartLine_Manuale_Installazione.pdf",
    "related": [
      "SmartLine 020-4",
      "SmartLine 036-4"
    ]
  },
  {
    "sigla": "SmartLine 020-4",
    "extended": "Centrale antincendio 4 zone",
    "brand": "INIM",
    "famiglia": "SmartLine",
    "categoria": "Antincendio",
    "spec_key": "4 zone espandibili a 20, EN54-2/4/21 + EN12094-1",
    "primary_manual": "SmartLine_Manuale_Installazione.pdf",
    "related": [
      "SmartLine 020-2",
      "SmartLine 036-4"
    ]
  },
  {
    "sigla": "SmartLine 036-4",
    "extended": "Centrale antincendio 36 zone",
    "brand": "INIM",
    "famiglia": "SmartLine",
    "categoria": "Antincendio",
    "spec_key": "4 zone espandibili a 36, 32 disp/zona",
    "primary_manual": "SmartLine_Manuale_Installazione.pdf",
    "related": [
      "SmartLine 020-4"
    ]
  },
  {
    "sigla": "Air2-BS200",
    "extended": "Sirena wireless Air2",
    "brand": "INIM",
    "famiglia": "Air2",
    "categoria": "Sirene wireless",
    "spec_key": "Sirena wireless per SmartLiving/Prime",
    "primary_manual": "Air2-BS200_Manuale_Installazione.pdf",
    "related": [
      "Air2-Hedera"
    ]
  },
  {
    "sigla": "Air2-Hedera",
    "extended": "Sirena outdoor Air2",
    "brand": "INIM",
    "famiglia": "Air2",
    "categoria": "Sirene wireless",
    "spec_key": "Sirena esterna wireless",
    "primary_manual": "Air2-Hedera_Manuale_Installazione.pdf",
    "related": [
      "Air2-BS200"
    ]
  },
  {
    "sigla": "Air2-Smarty",
    "extended": "Tastiera wireless Air2",
    "brand": "INIM",
    "famiglia": "Air2",
    "categoria": "Tastiere wireless",
    "spec_key": "Tastiera wireless per SmartLiving",
    "primary_manual": "Air2-SmartyW_Manuale_Installazione.pdf",
    "related": []
  },
  {
    "sigla": "Previdia Ultra",
    "extended": "Centrale antincendio modulare top",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia",
    "categoria": "Antincendio",
    "spec_key": "Fino 16 loop, 240 disp/loop, EN54-2/4/13/16/21 + EVAC/PA",
    "primary_manual": "Previdia_Ultra_Manuale_Installazione.pdf",
    "related": [
      "Previdia Max",
      "Previdia Compact"
    ]
  },
  {
    "sigla": "Previdia Max",
    "extended": "Centrale antincendio grande",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia",
    "categoria": "Antincendio",
    "spec_key": "Fino 4 loop, 240 disp/loop, EN54",
    "primary_manual": "Previdia_Max_Manuale_Installazione.pdf",
    "related": [
      "Previdia Ultra"
    ]
  },
  {
    "sigla": "Previdia Micro",
    "extended": "Centrale antincendio media",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia",
    "categoria": "Antincendio",
    "spec_key": "1-2 loop, 240 disp/loop",
    "primary_manual": "Previdia_Micro_Manuale_Installazione.pdf",
    "related": [
      "Previdia Compact"
    ]
  },
  {
    "sigla": "Previdia Compact C100SG",
    "extended": "Compact serie S 1 loop",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia Compact",
    "categoria": "Antincendio",
    "spec_key": "1 loop 240 punti (serie S, NON 2 loop). G = grigio. Batterie 1,5/7 Ah",
    "primary_manual": "Previdia_Compact_Manuale_Installazione.pdf",
    "related": [
      "Previdia Compact C100L",
      "C-REPW"
    ]
  },
  {
    "sigla": "Previdia Compact C100L",
    "extended": "Compact serie L 2 loop",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia Compact",
    "categoria": "Antincendio",
    "spec_key": "2 loop 240 punti (serie L, large). Batterie 4/17 Ah",
    "primary_manual": "Previdia_Compact_Manuale_Installazione.pdf",
    "related": [
      "Previdia Compact C100SG",
      "Previdia Compact C200L"
    ]
  },
  {
    "sigla": "Previdia Compact base",
    "extended": "Compact modelli piccoli",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia Compact",
    "categoria": "Antincendio",
    "spec_key": "1 loop 64 punti (modelli base)",
    "primary_manual": "Previdia_Compact_Manuale_Installazione.pdf",
    "related": [
      "Previdia Compact C100SG"
    ]
  },
  {
    "sigla": "C-REPW",
    "extended": "Repeater Previdia Compact wireless variant",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia",
    "categoria": "Repeater",
    "spec_key": "Pannello remoto, su bus Hornet+",
    "primary_manual": "C-REPW_Manuale_Installazione.pdf",
    "related": [
      "C-REP",
      "C-REPE"
    ]
  },
  {
    "sigla": "C-REP",
    "extended": "Repeater Previdia Compact",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia",
    "categoria": "Repeater",
    "spec_key": "Pannello remoto base, su bus Hornet+",
    "primary_manual": "C-REP_Manuale_Installazione.pdf",
    "related": [
      "C-REPW",
      "C-REPE"
    ]
  },
  {
    "sigla": "C-DIAL",
    "extended": "Modulo comunicatore PSTN/GSM/GPRS",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia",
    "categoria": "Comunicatori",
    "spec_key": "Modulo PSTN/GSM/GPRS per Previdia",
    "primary_manual": "C-DIAL_Manuale_Installazione.pdf",
    "related": [
      "C-COM"
    ]
  },
  {
    "sigla": "C-COM",
    "extended": "Modulo seriale/IP",
    "brand": "INIM_EXTRA",
    "famiglia": "Previdia",
    "categoria": "Comunicatori",
    "spec_key": "Modulo seriale/IP. C-COM-LAN ha Ethernet",
    "primary_manual": "C-COM_Manuale_Installazione.pdf",
    "related": [
      "C-DIAL"
    ]
  },
  {
    "sigla": "Hornet+",
    "extended": "Bus RS485 doppio tra centrali Previdia",
    "brand": "INIM_EXTRA",
    "famiglia": "Bus",
    "categoria": "Bus/Cablaggio",
    "spec_key": "Cavo Cat.5 S/FTP FR PH(120). 1000m@230kbps / 500m@512kbps. Morsetti +24/A+/A-/- + +24/B+/B-/-",
    "primary_manual": "Previdia_Compact_Manuale_Installazione.pdf",
    "related": []
  },
  {
    "sigla": "XP95",
    "extended": "Famiglia rivelatori a indirizzo base",
    "brand": "INIM_EXTRA",
    "famiglia": "Apollo",
    "categoria": "Rivelatori",
    "spec_key": "Rivelatori ottici/termici/multisensor di base EN54",
    "primary_manual": null,
    "related": [
      "Discovery",
      "Soteria",
      "ORBIS"
    ]
  },
  {
    "sigla": "Discovery",
    "extended": "Rivelatori Premium Apollo",
    "brand": "INIM_EXTRA",
    "famiglia": "Apollo",
    "categoria": "Rivelatori",
    "spec_key": "Premium, EN54-23 VAD",
    "primary_manual": null,
    "related": [
      "XP95"
    ]
  },
  {
    "sigla": "Soteria",
    "extended": "Rivelatori Apollo nuova generazione",
    "brand": "INIM_EXTRA",
    "famiglia": "Apollo",
    "categoria": "Rivelatori",
    "spec_key": "Generazione successiva XP95, Dimension",
    "primary_manual": null,
    "related": [
      "XP95"
    ]
  },
  {
    "sigla": "ORBIS",
    "extended": "Rivelatori convenzionali Apollo",
    "brand": "INIM_EXTRA",
    "famiglia": "Apollo",
    "categoria": "Rivelatori",
    "spec_key": "Rivelatori convenzionali e IS (Intrinsically Safe)",
    "primary_manual": null,
    "related": []
  },
  {
    "sigla": "SE126K",
    "extended": "Rivelatore gas domestico",
    "brand": "INIM_EXTRA",
    "famiglia": "Tecnocontrol",
    "categoria": "Gas",
    "spec_key": "Metano/GPL domestico, EN50244",
    "primary_manual": null,
    "related": [
      "SE127K",
      "SE128K"
    ]
  },
  {
    "sigla": "TS293",
    "extended": "Trasmettitore gas",
    "brand": "INIM_EXTRA",
    "famiglia": "Tecnocontrol",
    "categoria": "Gas",
    "spec_key": "Trasmettitore Tecnocontrol",
    "primary_manual": "TS293I.pdf",
    "related": [
      "TS282",
      "TS593"
    ]
  },
  {
    "sigla": "Stratos Micra",
    "extended": "Rivelatori aspirazione fumo",
    "brand": "INIM_EXTRA",
    "famiglia": "Stratos",
    "categoria": "Aspirazione fumo",
    "spec_key": "Per ambienti grandi/critici (data center, alti soffitti)",
    "primary_manual": null,
    "related": []
  }
];

export { ALIASES_GLOSSARY };
export default ALIASES_GLOSSARY;